import React, { useState, useEffect } from 'react';
import { Globe, MapPin, Phone, Mail, Clock, Instagram, MessageCircle , Facebook, Send, Navigation, Star } from 'lucide-react';

const ContactPage = () => {
  const [language, setLanguage] = useState('fr');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const content = {
    fr: {
      title: 'Contactez-Nous',
      subtitle: 'Nous Sommes à Votre Écoute',
      heroDesc: 'Notre équipe dévouée est là pour répondre à toutes vos questions et vous accompagner dans la préparation de votre séjour inoubliable au Riad Lina.',
      welcome: 'Bienvenue au Riad Lina',
      welcomeText: 'Nous serions ravis de vous accueillir dans notre havre de paix au cœur de Tafraoute. N\'hésitez pas à nous contacter pour toute demande de réservation, renseignement ou conseil sur votre séjour.',
      infoTitle: 'Informations de Contact',
      address: 'Adresse',
      addressLine1: 'TANDILT-AMMELNE-TAFROUT',
      addressLine3: 'Maroc',
      phone: 'Téléphone',
      phoneNumber: '+212 667 624183',
      email: 'Email',
      emailAddress: 'CONTACT@RAIDLINA.MA',
      hours: 'Horaires',
      hoursText: 'Réception ouverte 24h/24',
      hoursDetail: 'Service disponible tous les jours',
      locationTitle: 'Notre Emplacement',
      locationDesc: 'Niché dans la magnifique vallée d\'Ammelne, le Riad Lina bénéficie d\'un emplacement exceptionnel avec vue panoramique sur les montagnes de l\'Anti-Atlas.',
      directionsTitle: 'Comment Nous Trouver',
      directions: [
        'À 161 km d\'Agadir (2h45 en voiture)',
        'À 105 km de Tiznit (2h11 en voiture)',
        'Au cœur de Tafraoute, facilement accessible',
        'Parking gratuit disponible'
      ],
      socialTitle: 'Suivez-Nous',
      socialText: 'Découvrez nos dernières actualités et partagez votre expérience',
      bookingTitle: 'Réservation',
      bookingText: 'Pour réserver votre chambre ou suite, contactez-nous directement par téléphone ou email. Notre équipe vous répondra dans les plus brefs délais.',
      whyContact: 'Pourquoi Nous Contacter ?',
      contact: {
        title: 'Réservez Votre Séjour',
        address: 'TANDILT-AMMELNE-TAFROUT',
        phone: '+212 667 624183',
        whatssap: '+212 667 624183',
        email: 'CONTACT@RAIDLINA.MA'
      },
      reasons: [
        'Demande de réservation personnalisée',
        'Informations sur nos chambres et tarifs',
        'Conseils sur les activités et excursions',
        'Organisation d\'événements spéciaux',
        'Questions sur les services disponibles'
      ]
    },
    
  };

  const t = content[language];

  return (
    <div style={{ fontFamily: 'Georgia, serif', background: '#0a0a0a', color: '#fff' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;900&family=Cormorant+Garamond:wght@300;400;600;700&display=swap');
        
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Cormorant Garamond', serif; }
        
        // .fade-in { animation: fadeIn 1.2s ease-out; }
        // @keyframes fadeIn { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
        
        // .slide-in { animation: slideIn 0.8s ease-out; }
        // @keyframes slideIn { from { opacity: 0; transform: translateX(-60px); } to { opacity: 1; transform: translateX(0); } }
        
        // .zoom-in { animation: zoomIn 0.8s ease-out; }
        // @keyframes zoomIn { from { opacity: 0; transform: scale(0.85); } to { opacity: 1; transform: scale(1); } }
        
        // .float { animation: float 6s ease-in-out infinite; }
        // @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-20px); } }
        
        .luxury-card {
          background: linear-gradient(145deg, #1a1a1a, #0d0d0d);
          border: 1px solid rgba(212, 175, 55, 0.2);
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .luxury-card:hover {
          transform: translateY(-12px);
          border-color: rgba(212, 175, 55, 0.6);
          box-shadow: 0 25px 60px rgba(212, 175, 55, 0.25);
        }
        
        .gold-line {
          background: linear-gradient(90deg, transparent, #d4af37, transparent);
          height: 2px;
        }
        
        .ornament {
          background: url("data:image/svg+xml,%3Csvg width='100' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 10 Q 25 0, 50 10 T 100 10' stroke='%23d4af37' stroke-width='2' fill='none'/%3E%3C/svg%3E") center no-repeat;
          width: 100px;
          height: 20px;
        }
        
        .text-gradient {
          background: linear-gradient(135deg, #d4af37 0%, #f9e79f 50%, #d4af37 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .contact-icon-wrapper {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(212, 175, 55, 0.2), rgba(212, 175, 55, 0.05));
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          transition: all 0.4s;
        }
        
        .luxury-card:hover .contact-icon-wrapper {
          background: linear-gradient(135deg, #d4af37, #f9e79f);
          transform: scale(1.1) rotate(10deg);
        }
        
        .map-container {
          border-radius: 20px;
          overflow: hidden;
          border: 2px solid rgba(212, 175, 55, 0.3);
          box-shadow: 0 20px 60px rgba(0,0,0,0.4);
        }
      `}</style>

      {/* Hero Section */}
      <section style={{
        position: 'relative',
        height: '100vh',
        backgroundImage: 'url(https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=1600)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.8))'
        }} />
        
        <div style={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          textAlign: 'center', width: '90%', maxWidth: '1000px'
        }} className="fade-in">
          <div className="ornament" style={{ margin: '0 auto 30px' }} />
          <h1 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: 'clamp(50px, 8vw, 100px)',
            fontWeight: 900,
            marginBottom: '30px',
            letterSpacing: '4px',
            textShadow: '3px 3px 30px rgba(0,0,0,0.8)'
          }} className="text-gradient float">
            {t.title}
          </h1>
          <p style={{
            fontSize: 'clamp(24px, 4vw, 36px)',
            marginBottom: '40px',
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic',
            color: '#d4af37',
            textShadow: '2px 2px 15px rgba(0,0,0,0.7)'
          }}>
            {t.subtitle}
          </p>
          <div className="gold-line" style={{ width: '200px', margin: '0 auto 50px' }} />
          <p style={{
            fontSize: 'clamp(16px, 2.5vw, 22px)',
            lineHeight: '1.8',
            maxWidth: '800px',
            margin: '0 auto',
            color: '#e0e0e0',
            textShadow: '1px 1px 10px rgba(0,0,0,0.8)'
          }}>
            {t.heroDesc}
          </p>
        </div>
      </section>

      {/* Welcome Section */}
      <section style={{ padding: '120px 30px', background: '#0f0f0f' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }} className="slide-in">
          <h2 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: 'clamp(36px, 5vw, 60px)',
            color: '#d4af37',
            marginBottom: '30px',
            fontWeight: 900
          }}>
            {t.welcome}
          </h2>
          <div className="gold-line" style={{ width: '150px', margin: '0 auto 50px' }} />
          <p style={{
            fontSize: 'clamp(18px, 2.5vw, 24px)',
            lineHeight: '1.9',
            color: '#ccc',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            {t.welcomeText}
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section style={{ padding: '100px 30px', background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(36px, 5vw, 60px)',
              fontWeight: 900,
              marginBottom: '20px'
            }} className="text-gradient">
              {t.infoTitle}
            </h2>
            <div className="gold-line" style={{ width: '150px', margin: '0 auto' }} />
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '40px' }}>
            <div className="luxury-card zoom-in" style={{
              padding: '50px 30px',
              borderRadius: '20px',
              textAlign: 'center'
            }}>
              <div className="contact-icon-wrapper">
                <MapPin size={32} color="#d4af37" />
              </div>
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '26px',
                color: '#d4af37',
                marginBottom: '20px',
                fontWeight: 700
              }}>
                {t.address}
              </h3>
              <p style={{ fontSize: '18px', color: '#bbb', lineHeight: '1.8' }}>
                {t.addressLine1}<br />
                {t.addressLine2}<br />
                {t.addressLine3}
              </p>
            </div>

            <div className="luxury-card zoom-in" style={{
              padding: '50px 30px',
              borderRadius: '20px',
              textAlign: 'center'
            }}>
              <div className="contact-icon-wrapper">
                <Phone size={32} color="#d4af37" />
              </div>
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '26px',
                color: '#d4af37',
                marginBottom: '20px',
                fontWeight: 700
              }}>
                {t.phone}
              </h3>
              <a href={`tel:${t.phoneNumber}`} style={{
                fontSize: '20px',
                color: '#bbb',
                textDecoration: 'none',
                transition: 'color 0.3s'
              }} onMouseEnter={e => e.target.style.color = '#d4af37'}
                 onMouseLeave={e => e.target.style.color = '#bbb'}>
                {t.phoneNumber}
              </a>
            </div>

            <div className="luxury-card zoom-in" style={{
              padding: '50px 30px',
              borderRadius: '20px',
              textAlign: 'center'
            }}>
              <div className="contact-icon-wrapper">
                <Mail size={32} color="#d4af37" />
              </div>
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '26px',
                color: '#d4af37',
                marginBottom: '20px',
                fontWeight: 700
              }}>
                {t.email}
              </h3>
              <a href={`mailto:${t.emailAddress}`} style={{
                fontSize: '18px',
                color: '#bbb',
                textDecoration: 'none',
                transition: 'color 0.3s'
              }} onMouseEnter={e => e.target.style.color = '#d4af37'}
                 onMouseLeave={e => e.target.style.color = '#bbb'}>
                {t.emailAddress}
              </a>
            </div>

            <div className="luxury-card zoom-in" style={{
              padding: '50px 30px',
              borderRadius: '20px',
              textAlign: 'center'
            }}>
              <div className="contact-icon-wrapper">
                <Clock size={32} color="#d4af37" />
              </div>
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '26px',
                color: '#d4af37',
                marginBottom: '20px',
                fontWeight: 700
              }}>
                {t.hours}
              </h3>
              <p style={{ fontSize: '18px', color: '#bbb', lineHeight: '1.8' }}>
                {t.hoursText}<br />
                <span style={{ fontSize: '16px', color: '#888' }}>{t.hoursDetail}</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section style={{ padding: '120px 30px', background: '#0f0f0f' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }} className="fade-in">
            <h2 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(36px, 5vw, 60px)',
              fontWeight: 900,
              marginBottom: '20px'
            }} className="text-gradient">
              {t.locationTitle}
            </h2>
            <div className="gold-line" style={{ width: '150px', margin: '0 auto 30px' }} />
            <p style={{
              fontSize: 'clamp(16px, 2.5vw, 20px)',
              lineHeight: '1.8',
              color: '#ccc',
              maxWidth: '900px',
              margin: '0 auto'
            }}>
              {t.locationDesc}
            </p>
          </div>

          <div className="map-container" style={{ height: '500px', marginBottom: '60px' }}>
            <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.5257234595733!2d-8.9597194!3d29.7624364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdb6b10011b56089%3A0x5443cde1fee2be0d!2sRiad%20lina!5e0!3m2!1sen!2sma!4v1763645657758!5m2!1sen!2sma"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px'
          }}>
            <div className="luxury-card" style={{
              padding: '40px',
              borderRadius: '20px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '25px'
              }}>
                <Navigation size={28} color="#d4af37" />
                <h3 style={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '24px',
                  color: '#d4af37',
                  fontWeight: 700
                }}>
                  {t.directionsTitle}
                </h3>
              </div>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {t.directions.map((item, i) => (
                  <li key={i} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '15px',
                    fontSize: '17px',
                    color: '#bbb'
                  }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: '#d4af37'
                    }} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="luxury-card" style={{
              padding: '40px',
              borderRadius: '20px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '25px'
              }}>
                <Star size={28} color="#d4af37" />
                <h3 style={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '24px',
                  color: '#d4af37',
                  fontWeight: 700
                }}>
                  {t.whyContact}
                </h3>
              </div>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {t.reasons.map((item, i) => (
                  <li key={i} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '15px',
                    fontSize: '17px',
                    color: '#bbb'
                  }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: '#d4af37'
                    }} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Social & Booking Section */}
      <section style={{ padding: '100px 30px', background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '50px'
          }}>
            <div className="luxury-card" style={{
              padding: '50px',
              borderRadius: '20px',
              textAlign: 'center'
            }}>
              <Send size={48} color="#d4af37" style={{ marginBottom: '25px' }} />
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '32px',
                color: '#d4af37',
                marginBottom: '20px',
                fontWeight: 700
              }}>
                {t.socialTitle}
              </h3>
              <p style={{
                fontSize: '18px',
                color: '#bbb',
                lineHeight: '1.7',
                marginBottom: '30px'
              }}>
                {t.socialText}
              </p>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px'
              }}>
                <a href="https://www.instagram.com/riadlina_tafraout?igsh=MnRuanZrZzJ4dW44" style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'rgba(212, 175, 55, 0.1)',
                  border: '2px solid rgba(212, 175, 55, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s',
                  textDecoration: 'none'
                }} onMouseEnter={e => {
                  e.currentTarget.style.background = '#d4af37';
                  e.currentTarget.style.borderColor = '#d4af37';
                }} onMouseLeave={e => {
                  e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.3)';
                }}>
                  <Instagram size={24} color="#d4af37" />
                </a>
                  <a 
                  href="https://wa.me/212667624183" // Morocco country code (212) + your number without the leading 0
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'rgba(212, 175, 55, 0.1)',
                    border: '2px solid rgba(212, 175, 55, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = '#d4af37';
                    e.currentTarget.style.borderColor = '#d4af37';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)';
                    e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.3)';
                  }}
                >
                  <MessageCircle size={24} color="#d4af37" />
                </a>

                {/* <a href="#" style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'rgba(212, 175, 55, 0.1)',
                  border: '2px solid rgba(212, 175, 55, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s',
                  textDecoration: 'none'
                }} onMouseEnter={e => {
                  e.currentTarget.style.background = '#d4af37';
                  e.currentTarget.style.borderColor = '#d4af37';
                }} onMouseLeave={e => {
                  e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.3)';
                }}>
                  <Facebook size={24} color="#d4af37" />
                </a> */}
              </div>
            </div>

            <div className="luxury-card" style={{
              padding: '50px',
              borderRadius: '20px',
              textAlign: 'center'
            }}>
              <Phone size={48} color="#d4af37" style={{ marginBottom: '25px' }} />
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '32px',
                color: '#d4af37',
                marginBottom: '20px',
                fontWeight: 700
              }}>
                {t.bookingTitle}
              </h3>
              <p style={{
                fontSize: '18px',
                color: '#bbb',
                lineHeight: '1.7',
                marginBottom: '30px'
              }}>
                {t.bookingText}
              </p>
              <button style={{
                background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
                color: '#000',
                padding: '16px 40px',
                fontSize: '18px',
                border: 'none',
                borderRadius: '50px',
                cursor: 'pointer',
                fontWeight: 700,
                letterSpacing: '1px',
                transition: 'all 0.3s',
                fontFamily: 'Playfair Display, serif',
                boxShadow: '0 10px 40px rgba(212, 175, 55, 0.4)'
              }} onMouseEnter={e => { e.target.style.transform = 'scale(1.05)'; e.target.style.boxShadow = '0 15px 50px rgba(212, 175, 55, 0.6)'; }}
                 onMouseLeave={e => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 10px 40px rgba(212, 175, 55, 0.4)'; }}>
                {language === 'fr' ? 'Réserver Maintenant' : 'Book Now'}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" style={{
          padding: '120px 30px',
          background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
          color: '#fff'
          }}>
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }} className="scale-in">
            <h2 style={{
              fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
              marginBottom: '30px', fontWeight: 700
            }}>
            RIAD LINA

            </h2>
            <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto 60px' }} />
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginBottom: '50px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                <MapPin size={40} color="#d4af37" />
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Adresse</h3>
                <p style={{ fontSize: '16px' }}>{t.contact.address}</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                <Phone size={40} color="#d4af37" />
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Téléphone</h3>
              <p style={{ fontSize: '16px' }}>{t.contact.phone}</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                <Mail size={40} color="#d4af37" />
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Email</h3>
                <p style={{ fontSize: '16px' }}>{t.contact.email}</p>
              </div>
            </div>
  
            <button style={{
              background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
              color: '#000', padding: '18px 50px', fontSize: '18px',
              border: 'none', borderRadius: '50px', cursor: 'pointer',
              fontWeight: 700, letterSpacing: '2px', transition: 'all 0.4s',
                }}>
              Réserver Maintenant      
              </button>
          </div>
      </section>
    </div>
  );
};

export default ContactPage;

